import { render, staticRenderFns } from "./FaceGestureEnable.vue?vue&type=template&id=cec3d960"
import script from "./FaceGestureEnable.vue?vue&type=script&lang=js"
export * from "./FaceGestureEnable.vue?vue&type=script&lang=js"
import style0 from "./FaceGestureEnable.vue?vue&type=style&index=0&id=cec3d960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports